import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Sol_Story from "../Components/Component/Sol_Story";
import Consulting from "../Components/Component/Consulting";
import Bg from "../Components/Component/sol_bg";
import Complete from "../Components/Component/Complete";
import MaintenanceSection from "../Components/Component/MaintenanceSection";
import Work from "../Components/Component/Work";
import Footer from "../Components/Component/Footer";

const Our_Solution = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100); // wait for render
      }
    }
  }, [location]);

  return (
    <div>
      <Sol_Story />

      {/* MEP Offering */}
      <div id="mep">
        <Consulting />
      </div>

      {/* Solar Offering */}
      <div id="solar">
        <Bg />
      </div>

      {/* Electrical & Automation Panels */}
      <div id="panels">
        <Complete />
      </div>

      {/* Asset Management */}
      <div id="asset">
        <MaintenanceSection />
      </div>

      <Work />
      <Footer />
    </div>
  );
};

export default Our_Solution;